import * as React from 'react';

const SvgPlayEmpty = (props) => (
  <svg
    viewBox='0 0 72 72'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36Zm-6.5-24.742L49 36 29.5 24.742v22.516Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgPlayEmpty;
